import type { IUser } from '@manager/api/types/auth-types';
import { buildModalRoute } from '@manager/modules/modals/routable/modal-routable-utils';
import type { RouteRecordRaw } from 'vue-router';

/** The steps that issue a credit note or settle an invoice check their own permission. */
export function canOpenMoveOutWizard(user: IUser | undefined): boolean {
  return !!user?.tenant_features.uses_kinnovis_billing;
}

export function buildMoveOutModalRoute(
  name: string,
  path: string
): RouteRecordRaw {
  return buildModalRoute(
    {
      name,
      path,
      meta: {
        requiresAuth: true,
        permission: 'bookings.update',
        additionalCheck: canOpenMoveOutWizard,
      },
      component: () =>
        import('@manager/modules/move-out/views/MoveOutWizardView.vue'),
    },
    { fullscreen: false, width: 'unset', closeOnBack: false }
  );
}
